import { render, staticRenderFns } from "./BhBackgroundSuicideSeverityStep1.vue?vue&type=template&id=829e0f50"
import script from "./BhBackgroundSuicideSeverityStep1.vue?vue&type=script&lang=js"
export * from "./BhBackgroundSuicideSeverityStep1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports